"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const date_fns_1 = require("date-fns");
const react_datepicker_1 = tslib_1.__importDefault(require("react-datepicker"));
const DatePickerWrapper_1 = tslib_1.__importStar(require("./DatePickerWrapper"));
class CustomDateTimePicker extends React.Component {
    constructor() {
        super(...arguments);
        this.handleChangeRaw = (e) => {
            if ((0, date_fns_1.isValid)(e.target.value)) {
                this.props.onChange(new Date(e.target.value));
            }
        };
    }
    render() {
        const _a = this.props, { disabled, showYearDropdown, value, onChange, timeIntervals, dateFormat } = _a, other = tslib_1.__rest(_a, ["disabled", "showYearDropdown", "value", "onChange", "timeIntervals", "dateFormat"]);
        return (React.createElement(DatePickerWrapper_1.default, null,
            React.createElement(react_datepicker_1.default, Object.assign({ dateFormat: dateFormat, timeFormat: "HH:mm", placeholderText: "dd.MM.yyyy hh:mm", timeIntervals: timeIntervals, showTimeSelect: true, selected: value, onChange: onChange, onChangeRaw: this.handleChangeRaw, disabled: disabled, isClearable: !disabled, showYearDropdown: showYearDropdown, customInput: React.createElement(DatePickerWrapper_1.Input, Object.assign({}, other)), timeCaption: "\u010Cas" }, other))));
    }
}
exports.default = CustomDateTimePicker;
CustomDateTimePicker.defaultProps = {
    disabled: false,
    isClearable: true,
    showYearDropdown: true,
    value: null,
    timeIntervals: 5,
    dateFormat: 'dd.MM.yyyy HH:mm',
};
